import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Check, Clock, Mail, FileText, ArrowLeft } from 'lucide-react';
import './RegistrationSuccess.css';

const RegistrationSuccess = () => {
  const location = useLocation();
  const { agency, agencyCode } = location.state || { agency: 'the agency', agencyCode: '' };

  return (
    <div className="registration-success-page">
      <div className="success-container">
        <div className="success-header">
          <div className="success-icon">
            <div className="success-circle">
              <Check className="check-icon" />
            </div>
          </div>
          <h1>Application Submitted Successfully!</h1>
          <p className="success-subtitle">Thank you for applying to join {agency}</p>
        </div>

        <div className="confirmation-card">
          <div className="confirmation-header">
            <h2>What Happens Next?</h2>
          </div>
          
          <div className="timeline-section">
            <div className="timeline-item">
              <div className="timeline-icon">
                <Clock className="icon" />
              </div>
              <div className="timeline-content">
                <h3>Within 24 Hours</h3>
                <p>Your application will be reviewed by the {agency} admin team. Most applications are processed within 24 hours during business days.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <Mail className="icon" />
              </div>
              <div className="timeline-content">
                <h3>Email Notification</h3>
                <p>You'll receive an email notification once your application has been approved. This email will contain your login credentials and next steps.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <FileText className="icon" />
              </div>
              <div className="timeline-content">
                <h3>Tax Form Submitted</h3>
                <p>Your tax form has been submitted with your application. Once approved, you'll be ready to start creating quotes and serving clients.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="next-steps-card">
          <h3>While You Wait</h3>
          <ul className="next-steps-list">
            <li>
              <span className="step-icon">📧</span>
              <span>Check your email regularly for approval notification</span>
            </li>
            <li>
              <span className="step-icon">📚</span>
              <span>Review {agency}'s training materials if provided</span>
            </li>
            <li>
              <span className="step-icon">🔔</span>
              <span>Add admin@{agency.toLowerCase().replace(/\s+/g, '')}.com to your contacts to avoid missing emails</span>
            </li>
            <li>
              <span className="step-icon">💼</span>
              <span>Prepare your professional photo and bio for your agent profile</span>
            </li>
          </ul>
        </div>

        <div className="agency-info-card">
          <h3>Application Details</h3>
          <div className="detail-row">
            <span className="detail-label">Agency</span>
            <span className="detail-value">{agency}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Application Date</span>
            <span className="detail-value">{new Date().toLocaleDateString()}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Expected Response</span>
            <span className="detail-value">Within 24 hours</span>
          </div>
        </div>

        <div className="action-buttons">
          {agencyCode && (
            <Link to={`/${agencyCode}/login`} className="primary-button">
              <ArrowLeft className="button-icon" />
              Return to {agency} Login
            </Link>
          )}
          <Link to="/" className="secondary-button">
            Go to Home Page
          </Link>
        </div>

        <div className="footer-note">
          <p>Have questions? Contact {agency} support</p>
          <p>Thank you for choosing to partner with {agency}!</p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
